import http from './api'

const route = 'app/financeiro/fluxo-caixa2/'

export default {
  showGraficoProjecaoFinanceiraFC2: (username, tokenContrato, select) => {
    return http.post(route + 'showGraficoProjecaoFinanceiraFC2', {
      username: username,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showValoresEmAtraso7Dias: (tokenContrato, select) => {
    return http.post(route + 'showValoresEmAtraso7Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showValoresEm7Dias: (tokenContrato, select) => {
    return http.post(route + 'showValoresEm7Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showValoresEm14Dias: (tokenContrato, select) => {
    return http.post(route + 'showValoresEm14Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showValoresEm21Dias: (tokenContrato, select) => {
    return http.post(route + 'showValoresEm21Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showValoresEm28Dias: (tokenContrato, select) => {
    return http.post(route + 'showValoresEm28Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showValoresEm35Dias: (tokenContrato, select) => {
    return http.post(route + 'showValoresEm35Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showMovimentacaoMensalFC2: (tokenContrato, select) => {
    return http.post(route + 'showMovimentacaoMensalFC2', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoReceberEmAtraso: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoReceberEmAtraso', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoReceberEm7Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoReceberEm7Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoReceberEm14Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoReceberEm14Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoReceberEm21Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoReceberEm21Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoReceberEm28Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoReceberEm28Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoReceberEm35Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoReceberEm35Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoPagarEmAtraso: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoPagarEmAtraso', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoPagarEm7Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoPagarEm7Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoPagarEm14Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoPagarEm14Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoPagarEm21Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoPagarEm21Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoPagarEm28Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoPagarEm28Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoPagarEm35Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoPagarEm35Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoSaldoEmAtraso: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoSaldoEmAtraso', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoData: (data, carteira, tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoData', {
      data: data,
      carteira: carteira,
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoSaldoEm7Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoSaldoEm7Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoSaldoEm14Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoSaldoEm14Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoSaldoEm21Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoSaldoEm21Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoSaldoEm28Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoSaldoEm28Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoSaldoEm35Dias: (tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoSaldoEm35Dias', {
      tokenContrato: tokenContrato,
      select: select,
    })
  },

  showDadosDelhamentoDataValoresAReceber: (data, carteira, tokenContrato, select) => {
    return http.post(route + 'showDadosDelhamentoDataValoresAReceber', {
      data: data,
      carteira: carteira,
      tokenContrato: tokenContrato,
      select: select,
    })
  },
}
